import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

export default () => {
  const { t } = useTranslation();

  return useMemo(
    () => [
      { label: t('id'), key: 'id' },
      { label: t('name'), key: 'type' },
    ],
    [t],
  );
};
